export default function empty() {
    return empty;
}
